import React from "react";

import AppCapisSource from "components/source_types/AppCapisSource";

/** Android / iOS CAPI package name field; submit lives in the modal footer. */
const AppCapiSourceForm = ({ form, appCapi }) => (
    <AppCapisSource
        form={form}
        appCapi={appCapi.appCapi}
        setAppCapi={appCapi.setAppCapi}
        fileError={appCapi.error}
        setFileError={appCapi.setError}
    />
);

export default AppCapiSourceForm;
